import { useHierarchyArea } from '@plarium/hierarchy-react';

import { loadDeepLinkConfig } from 'scenes/Campaigns/sources/fields';
import { loadLinksConfig } from 'scenes/Campaigns/sources/fields';

export const useLinksConfig = ({ name, active, depends, normalizeValue }) => {
  const { data } = useHierarchyArea({
    name: name,
    source: loadLinksConfig,
    active: active,
    depends: depends,
    normalizeValue: normalizeValue,
  });

  return {
    linksConfig: data,
  };
};

export const useDeepLinkConfig = ({
  name,
  active,
  depends,
  normalizeValue,
}) => {
  const { data } = useHierarchyArea({
    name: name,
    source: loadDeepLinkConfig,
    active: active,
    depends: depends,
    normalizeValue: normalizeValue,
  });

  return {
    isAllowedCreateDeepLinks: data?.isAllowed,
  };
};
